<template>
  <v-container class="newsPage">
    <v-row style="    width: -webkit-fill-available;">
      <div class="hidden-sm-and-down primary elevation-4 headerOne">
        <img
          src="../assets/Concord_Logo_Final.webp"
          style=" max-width: 15em;"
        />
        <h2 style=" color: white; font-size: 25px;  " id="headerText">
          A Community Built by Individuals
        </h2>
      </div>

      <div class="hidden-md-and-up primary headerTwo">
        <img
          src="../assets/Concord_Logo_Final.webp"
          style=" max-width: 44vw;"
        />
        <h2 style=" color: white; font-size: 3.5vw;" id="headerText">
          A Community Built by Individuals
        </h2>
      </div>

      <v-dialog
        transition="dialog-bottom-transition"
        v-model="reportDialog"
        width="auto"
        :fullscreen="$vuetify.breakpoint.xsOnly"
        style="border-radius: 10px; "
      >
        <v-card
          class="chatbackground"
          style=" border-radius: 10px; text-align: center;"
        >
          <div class="titles dialogDiv">
            <div class="noDialogBar"></div>
          </div>
          <div
            class="titles hidden-sm-and-up"
            style="
              padding: 0px 13px 5px;   "
            v-touch="{
              down: () => (reportDialog = false),
            }"
          >
            <div class="elevation-3 dialogBar"></div>
          </div>
          <v-card-title
            class="titles  "
            style="text-transform: capitalize; margin:auto; 
              padding-top: 0px;"
            v-touch="{
              down: () => (reportDialog = false),
            }"
          >
            <h3 class="reportText" v-if="reportSubmessageID != ''">
              Report '{{ reportSubmessage.substring(0, 20).trim() }}...'
            </h3>
            <h3 class="reportText" v-else-if="reportMessageID != ''">
              Report '{{ reportMessage.substring(0, 20).trim() }}...'
            </h3>
            <h3 class="reportText" v-else>
              Report '{{ reportForumTitle.substring(0, 20).trim() }}...'
            </h3>
          </v-card-title>

          <!-- report story -->
          <v-autocomplete
            v-if="reportSubmessageID === '' && reportMessageID === ''"
            v-model="chosenReason"
            :items="reportAutocomplete.story"
            solo
            dense
            chips
            small-chips
            label="Report Post Reason"
            class="reportAuto"
          >
            <template slot="selection" slot-scope="data" pa-5>
              <v-chip
                text-color="white"
                :selected="data.selected"
                close
                class="primary"
                @input="data.parent.selectItem(data.item)"
              >
                {{ data.item }}
              </v-chip>
            </template>

            <template slot="item" slot-scope="data">
              <v-list-tile-content v-text="data.item"></v-list-tile-content>
            </template>
          </v-autocomplete>

          <!-- report comment -->
          <v-autocomplete
            v-else
            v-model="chosenReason"
            :items="reportAutocomplete.comment"
            solo
            dense
            chips
            small-chips
            label="Report Comment Reason"
            class="reportAuto"
          >
            <template slot="selection" slot-scope="data" pa-5>
              <v-chip
                text-color="white"
                :selected="data.selected"
                close
                class="primary"
                @input="data.parent.selectItem(data.item)"
              >
                {{ data.item }}
              </v-chip>
            </template>

            <template slot="item" slot-scope="data">
              <v-list-tile-content v-text="data.item"></v-list-tile-content>
            </template>
          </v-autocomplete>

          <v-textarea
            v-model="reportReason"
            label="Additional Comments"
            solo
            style="width: 90%; margin: auto"
          >
          </v-textarea>

          <v-card-actions style="display: block;">
            <v-spacer></v-spacer>
            <v-btn
              class="danger elevation-4 dialogButton"
              text
              @click="report(), $forceUpdate()"
            >
              Report
            </v-btn>
            <v-btn
              class="titles elevation-4 dialogButton"
              text
              @click="resetReport(), $forceUpdate()"
            >
              Cancel
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        transition="dialog-bottom-transition"
        v-model="commentSourceDialog"
        width="auto"
        :fullscreen="$vuetify.breakpoint.xsOnly"
        style="border-radius: 10px; "
      >
        <v-card
          class="chatbackground"
          style="border-radius: 10px; text-align: center;"
        >
          <div class="titles dialogDiv">
            <div class="noDialogBar"></div>
          </div>
          <div
            class="titles hidden-sm-and-up"
            style="
              padding: 0px 13px 5px;   "
            v-touch="{
              down: () => (commentSourceDialog = false),
            }"
          >
            <div class="elevation-3 dialogBar"></div>
          </div>
          <v-card-title
            class="titles  "
            style="text-transform: capitalize; margin:auto;"
            v-touch="{
              down: () => (commentSourceDialog = false),
            }"
          >
            <h3 style="color:white;font-size: 28px; margin:auto;">
              add sources to your comment
            </h3>
          </v-card-title>
          <v-card-text style="text-transform: capitalize; font-weight: 600">
            Press enter or use commas to Separate Sources
          </v-card-text>
          <v-combobox
            multiple
            v-model="commentSources1"
            clearable
            :items="commentSources1"
            label="Sources"
            class="link-input"
            append-icon
            chips
            :search-input.sync="commentSources"
            @keyup.,="linkTabs"
            @paste="linkTabs"
            style="width: 90%; margin: auto;"
            solo
            deletable-chips
          >
            <template v-slot:selection="{ index }">
              <v-chip v-if="index == 0"
                ><v-icon style="font-size:20px; ">add_link</v-icon> &nbsp;{{
                  commentSources1.length
                }}
              </v-chip>
            </template>
            <template v-slot:item="{ item }">
              <v-icon style="font-size:20px; ">cancel</v-icon>
              <h3
                style="color: black; width: 100%; padding-left: 5px; white-space: nowrap;"
              >
                {{ item }}
              </h3>
            </template>
          </v-combobox>

          <v-card-actions style="display: block;">
            <v-spacer></v-spacer>
            <v-btn
              outline
              color="titles"
              text-color="titles"
              class=" elevation-4"
              text
              style="border-radius:20px;     text-transform: none; background: #f1ce3eb3 !important; font-weight: 600"
              @click="(commentSourceDialog = false), $forceUpdate()"
            >
              Save
            </v-btn>
            <v-btn
              class="titles elevation-4 dialogButton"
              text
              @click="
                (commentSourceDialog = false),
                  (commentSources = ''),
                  (commentSources1 = []),
                  (comment_id = ''),
                  (comment_source_isThread = false),
                  $forceUpdate()
              "
            >
              Remove
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        transition="dialog-bottom-transition"
        v-model="linkDialog"
        width="auto"
        :fullscreen="$vuetify.breakpoint.xsOnly"
        style="border-radius: 10px; "
      >
        <v-card
          class="chatbackground"
          style="border-radius: 10px; text-align: center;"
        >
          <div class="titles dialogDiv">
            <div class="noDialogBar"></div>
          </div>
          <div
            class="titles hidden-sm-and-up"
            style="
              padding: 0px 13px 5px;   "
            v-touch="{
              down: () => (linkDialog = false),
            }"
          >
            <div class="elevation-3 dialogBar"></div>
          </div>
          <v-card-title
            class="titles  "
            style="text-transform: capitalize;"
            v-touch="{
              down: () => (linkDialog = false),
            }"
          >
            <h4 style="color:white; font-size: 28px;   margin: auto;">
              Sources for '{{ link_forumTitle.substring(0, 20) }}'
            </h4>
          </v-card-title>

          <!-- links -->
          <div style="padding-top: 5px;">
            <template v-for="link in link_links">
              <v-chip
                :key="link + link_forumTitle"
                class="ma-2 secondary elevation-4"
                style="height:25px;"
                text-color="primary"
                @click="open(link)"
                >{{ link.match(/([a-zA-z.]*)/)[1] }}</v-chip
              >
            </template>
          </div>

          <v-card-actions style="display: block;">
            <v-spacer></v-spacer>
            <v-btn
              class="primary elevation-4 dialogButton"
              text
              @click="resetLink()"
            >
              Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-snackbar v-model="snackbar" bottom :timeout="2000" color="titles">
        Link Has Been Copied To Clipboard
      </v-snackbar>

      <template v-for="(n, news_index) in news" flat>
        <div
          v-bind="n"
          :key="n.forum_id + 'forum desktop'"
          style="display:inline"
          class="hidden-md-and-down"
        >
          <v-card
            class="elevation-0"
            style="max-width: 1200px;width: -webkit-fill-available;background: #00008b00; margin:auto"
          >
            <v-card
              class=" primary shadow"
              style=" border-radius: 10px; margin-bottom:25px; padding-bottom: 1px;     display: flex; justify-content: space-around;"
            >
              <div style="    width: 95%;">
                <div
                  style="display: flex; justify-content: space-between; height: 35px; color:white; align-items:center; padding-left: 10px; font-weight:600"
                >
                  {{ n.time }}
                </div>
                <v-carousel
                  lazy
                  class="elevation-0 carousel-concormobile"
                  style=" padding: 10px; padding-top: 0px;"
                  hide-delimiters
                  height="auto"
                  :cycle="false"
                  :continuous="false"
                  transition="fade-transition"
                  v-model="caro['desktop' + n.forum_id]"
                >
                  <v-carousel-item
                    flat
                    v-bind="n"
                    v-for="(item, i) in n.items"
                    :alt="n.title"
                    :key="i + n.title + n.forum_id + 'caro desktop'"
                    :src="item"
                    style="max-width: 700px; border-radius: 10px; border: 1px solid white"
                  >
                    <div
                      v-if="news_index == 0 && i == 0 && !seen"
                      id="desktopTutorial"
                      class="titles"
                      style="float: left;
                    position: relative;
                    z-index: 1000;
                    padding: 5px;
                    color: white;
                    font-weight: bold;
                    opacity: .8; font-size: 3vh;
                    display: flex;
                    width: 80%;
                    justify-content: center;
                    align-items: center;
                    left: 50%;
                    top: 51%;
                    border-radius: 10px;
                    -webkit-transform: translate(-50%, -50%);
                    transform: translate(-50%, -50%);"
                    >
                      Tap&nbsp;<v-icon
                        color="white"
                        style="font-size: 3.5vh; margin-left:3px; background: #ffffff30; border-radius: 50px;"
                        >chevron_right</v-icon
                      >&nbsp;To See More
                    </div>
                    <v-btn
                      class="carousel-concord-btn primary  "
                      fab
                      dark
                      small
                      style="color: white;opacity:.8; float:right"
                    >
                      <span style="font-size:11px"
                        >{{ i + 1 }}/{{ n.items.length }}</span
                      >
                    </v-btn>
                  </v-carousel-item>
                </v-carousel>
                <div
                  style="display: flex; justify-content: center; margin-top: -10px;"
                >
                  <div
                    v-for="i in n.items.length"
                    :key="i + 'desktop slides' + n.forum_id"
                  >
                    <v-icon
                      v-if="i - 1 == caro['desktop' + n.forum_id]"
                      color="secondary"
                      style="font-size: 10px; margin-left:3px;"
                      >adjust</v-icon
                    >
                    <v-icon
                      v-else
                      color="white"
                      style="font-size: 10px; margin-left:3px;"
                      @click="caro['desktop' + n.forum_id] = i - 1"
                      >adjust</v-icon
                    >
                  </div>
                </div>

                <div
                  v-show="n.tags.length > 0"
                  style="overflow-wrap: anywhere; white-space: break-spaces; margin:5px; text-align-last: center; text-align: -webkit-center;"
                >
                  <template v-for="(tag, i) in n.tags">
                    <v-chip
                      v-if="i != n.tags.length - 1"
                      :key="tag + n.title + n.forum_id + 'tags'"
                      @click="pushTag(tag)"
                      color="titles"
                      class="ma-2 elevation-4"
                      text-color="white"
                      >{{ tag }}</v-chip
                    >
                    <v-chip
                      v-else
                      :key="tag + n.title + n.forum_id + 'tags'"
                      @click="pushTag(tag)"
                      color="secondary"
                      class="ma-2 elevation-4"
                      text-color="titles"
                      >{{ tag }}</v-chip
                    >
                  </template>
                  <v-list
                    style=" padding-top:0; padding-bottom: 0; background-color:#6aaaff05"
                  >
                    <div
                      style="overflow-wrap: anywhere; white-space: break-spaces;"
                    >
                      <v-btn
                        v-show="n.links.length > 0"
                        @click="setLink(n.title, n.links, n.tags)"
                        class="secondary elevation-4 titles--text"
                        flat
                        fab
                        small
                      >
                        <v-icon dark style="font-size:20px; ">link</v-icon>
                      </v-btn>
                      <v-btn
                        outline
                        color="secondary"
                        text-color="secondary"
                        v-show="!n.userUpvotes.includes(userID)"
                        flat
                        class="upvote elevation-4"
                        style="border-radius: 20px;  height:40px; min-width:5px; color:white; padding: 10px;     font-weight: 600;"
                        @click="addStoryUpvote(n.forum_id)"
                      >
                        <v-icon dark style="font-size:20px; "
                          >star_border</v-icon
                        >
                        &nbsp; {{ n.count }}
                      </v-btn>
                      <v-btn
                        outline
                        color="secondary"
                        text-color="secondary"
                        v-show="n.userUpvotes.includes(userID)"
                        class="upvote elevation-4"
                        flat
                        lighten-2
                        @click="removeStoryUpvote(n.forum_id)"
                        style="border-radius: 20px;  height:40px; min-width:5px; color:white;padding: 10px;    font-weight: 600;"
                      >
                        <v-icon dark style="font-size:20px; ">star</v-icon>
                        &nbsp; {{ n.count }}
                      </v-btn>
                      <v-btn
                        flat
                        class="danger elevation-4 white--text"
                        fab
                        small
                        style="color:white; "
                        @click="shareStory(n, n.tags)"
                      >
                        <v-icon dark style="font-size:20px; ">ios_share</v-icon>
                      </v-btn>
                    </div>
                  </v-list>
                </div>
              </div>
              <div style="    width: 95%;">
                <div
                  style="display: flex; justify-content: flex-end; height:36px;"
                >
                  <v-btn
                    flat
                    small
                    style="color:white; margin: 10px; padding: 0 !important; min-width: 25px !important; margin-top: 5px; margin-bottom: 5px; border-radius: 20px;"
                    @click="setReport(n.forum_id, n.title, '', '', '', '')"
                  >
                    <v-icon dark style="font-size:20px; ">more_horiz</v-icon>
                  </v-btn>
                </div>
                <v-layout
                  row
                  style="padding: 0% 2% 3%; text-align:center; display: block; "
                >
                  <v-flex
                    style="padding-bottom: 15px; margin-left: 6px; margin-right: 6px;"
                  >
                    <v-select
                      id="desktopQTC"
                      :items="n.QTC"
                      v-model="n.chosen"
                      cache-items
                      flat
                      hide-no-data
                      hide-details
                      label="Respond to or Filter by a Question to Consider"
                      solo
                      dense
                      clearable
                      style="    white-space: pre-wrap;"
                    ></v-select>
                  </v-flex>
                  <div
                    class=" elevation-4"
                    style="display: flex; margin-top: 0px; margin-left: 6px; margin-right: 6px; border-radius: 10px;  background: white;"
                  >
                    <v-textarea
                      maxlength="1000"
                      style="padding:10px; border-radius:20px;"
                      counter="1000"
                      clearable
                      no-resize
                      :id="n.forum_id"
                      rows="2"
                      shaped
                      v-model="n.input"
                      label="Discuss..."
                      v-on:keyup.enter="
                        addMessage(n.forum_id), (n.chat = true), updateView()
                      "
                    >
                    </v-textarea>
                    <div
                      class="primary"
                      style="display:grid; border-radius: 0px 10px 10px 0px; border: 1px solid white !important; border-left: 0;"
                    >
                      <v-btn
                        v-if="
                          comment_id != n.forum_id ||
                            comment_source_isThread != false
                        "
                        outline
                        fab
                        dark
                        small
                        color="secondary"
                        class="elevation-3"
                        @click="
                          (commentSourceDialog = true),
                            (commentSources = ''),
                            (commentSources1 = []),
                            (comment_id = n.forum_id),
                            (comment_source_isThread = false)
                        "
                      >
                        <v-icon dark style="font-size:20px; color: #F1CE3E"
                          >add_link</v-icon
                        >
                      </v-btn>
                      <v-btn
                        v-else
                        outline
                        fab
                        dark
                        small
                        color="secondary"
                        class="elevation-3"
                        @click="commentSourceDialog = true"
                      >
                        <v-icon dark style="font-size:20px; color: #F1CE3E"
                          >link_off</v-icon
                        >
                      </v-btn>

                      <v-btn
                        fab
                        dark
                        small
                        class="titles elevation-3"
                        @click="
                          addMessage(n.forum_id), (n.chat = true), updateView()
                        "
                      >
                        <v-icon dark style="font-size:20px;  border-radius:50px"
                          >send</v-icon
                        >
                      </v-btn>
                    </div>
                  </div>
                </v-layout>

                <div
                  class="scroll-y chatbackground elevation-4"
                  id="scroll-target"
                  style="width: auto; height: 510px; border-radius: 10px; margin:12px;     margin-top: 0px;"
                >
                  <v-list
                    v-if="n.sortedMessages.length > 0"
                    id="scroll-container"
                    class="chatbackground"
                    two-line
                    v-scroll:#scroll-target
                    style="padding-top: 0px; padding-bottom: 0px;"
                  >
                    <template
                      v-for="item in n.sortedMessages"
                      pa-1
                      style="min-height:72px; "
                    >
                      <div
                        :key="
                          item.senderID +
                            n.title +
                            n.forum_id +
                            item.messageID +
                            ' desktop'
                        "
                        class="elevation-1 "
                        style="border-radius: 20px;  padding: 20px; padding-bottom:2px; margin:7px; background:white;"
                        v-show="
                          indexOfQTC(n) == -1 || indexOfQTC(n) == item.QTC
                        "
                      >
                        <div>
                          <p
                            pa-2
                            style="font-weight: bold; font-size:16px; padding-top: 2px;margin-bottom: 0px;  text-transform: capitalize; clear:both;"
                            class="text-wrap"
                            @click="$router.push('/profile/' + item.senderID)"
                          >
                            {{ item.sender }}
                          </p>
                          <p
                            v-show="!item.deleted"
                            pa-2
                            style="font-weight: bold;font-size:12px; padding-top: 2px;margin-bottom: 0px;  text-transform: capitalize; clear:both;"
                            class="text-wrap"
                          >
                            {{ item.time }}
                          </p>
                        </div>

                        <p
                          v-show="!item.deleted"
                          class="text-wrap"
                          style="font-size: 16px;margin-bottom: 0px;overflow-wrap: break-word;padding-right: 10px; display:block;white-space: normal;word-wrap: break-word;width: auto; clear:right"
                          pa-1
                        >
                          {{ item.message }}
                        </p>
                        <div
                          style="white-space: pre-wrap; display: flex; margin: 6px; justify-content: flex-end; margin-right: -14px;"
                        >
                          <div
                            style="width: min-content;border-radius: 20px;display: flex;text-align: center;"
                            class="primary elevation-3"
                          >
                            <v-btn
                              flat
                              fab
                              class="danger elevation-4"
                              small
                              style=" color:white; "
                              v-show="userID != item.senderID && !item.deleted"
                              @click="
                                setReport(
                                  n.forum_id,
                                  n.title,
                                  item.messageID,
                                  item.message,
                                  '',
                                  ''
                                )
                              "
                            >
                              <v-icon dark style="font-size:20px; "
                                >more_horiz</v-icon
                              >
                            </v-btn>
                            <v-btn
                              flat
                              fab
                              class="danger elevation-4"
                              small
                              v-show="userID == item.senderID && !item.deleted"
                              style="color:white;"
                              @click="removeMessage(n.forum_id, item.messageID)"
                            >
                              <v-icon dark style="font-size:20px; "
                                >delete_outline</v-icon
                              >
                            </v-btn>

                            <v-btn
                              v-show="item.links.length > 0"
                              @click="setLink(item.message, item.links, n.tags)"
                              class="secondary elevation-4 titles--text"
                              flat
                              fab
                              small
                            >
                              <v-icon dark style="font-size:20px; "
                                >link</v-icon
                              >
                            </v-btn>

                            <v-btn
                              outline
                              color="secondary"
                              text-color="secondary"
                              v-show="
                                !item.userUpvotes.includes(userID) &&
                                  !item.deleted
                              "
                              flat
                              class="upvote elevation-4"
                              style="border-radius: 20px;  height:40px; min-width:5px; color:white;  padding: 10px;     font-weight: 600;"
                              @click="
                                addMessageUpvote(n.forum_id, item.messageID)
                              "
                            >
                              <v-icon dark style="font-size:20px; "
                                >star_border</v-icon
                              >
                              &nbsp; {{ item.count }}
                            </v-btn>

                            <v-btn
                              outline
                              color="secondary"
                              text-color="secondary"
                              v-show="
                                item.userUpvotes.includes(userID) &&
                                  !item.deleted
                              "
                              flat
                              class="upvote elevation-4"
                              lighten-2
                              @click="
                                removeMessageUpvote(n.forum_id, item.messageID)
                              "
                              style="border-radius: 20px;  height:40px; min-width:5px;  padding: 10px; color:white;    font-weight: 600;"
                            >
                              <v-icon dark style="font-size:20px; "
                                >star</v-icon
                              >
                              &nbsp; {{ item.count }}
                            </v-btn>

                            <v-btn
                              class="titles elevation-4"
                              v-show="item.threads"
                              @click="(item.threads = false), updateView()"
                              flat
                              pa-1
                              style="border-radius: 20px;min-width: 5px; padding: 10px;  height:40px;margin-bottom: 6px;  color:white;  font-weight: 600;"
                            >
                              <v-icon dark small style="font-size:22px; "
                                >speaker_notes</v-icon
                              >
                              &nbsp; {{ item.thread.length }}
                            </v-btn>
                            <v-btn
                              class="titles elevation-4"
                              v-show="!item.threads"
                              @click="(item.threads = true), updateView()"
                              flat
                              pa-1
                              style="border-radius: 20px; min-width: 5px; padding: 10px; height:40px;margin-bottom: 6px; color:white;  font-weight: 600;"
                            >
                              <v-icon dark small style="font-size:22px; "
                                >reply</v-icon
                              >
                              &nbsp; {{ item.thread.length }}
                            </v-btn>
                          </div>
                        </div>
                      </div>

                      <v-layout
                        v-show="
                          item.threads &&
                            (indexOfQTC(n) == -1 || indexOfQTC(n) == item.QTC)
                        "
                        :key="
                          item +
                            n.forum_id +
                            item.messageID +
                            'threads  desktop'
                        "
                        class="elevation-1 "
                        row
                        style=" border-radius: 20px;margin: 7px;margin-left: 45px; background:white"
                      >
                        <v-textarea
                          maxlength="1000"
                          clearable
                          no-resize
                          counter="1000"
                          style="padding:10px;  color:white; margin-left:20px"
                          rows="2"
                          :id="item.messageID"
                          label="Respond..."
                          v-model="item.input"
                          v-on:keyup.enter="
                            addMessageThread(n.forum_id, item.messageID)
                          "
                        >
                        </v-textarea>
                        <div
                          class="primary"
                          style="display:grid; border-radius: 0px 20px 20px 0px; border: 1px solid white !important; border-left: 0px;"
                        >
                          <v-btn
                            v-if="
                              comment_id != n.forum_id ||
                                comment_source_isThread != true
                            "
                            outline
                            fab
                            dark
                            small
                            color="secondary"
                            class="elevation-3"
                            @click="
                              (commentSourceDialog = true),
                                (commentSources = ''),
                                (commentSources1 = []),
                                (comment_id = n.forum_id),
                                (comment_source_isThread = true)
                            "
                          >
                            <v-icon dark style="font-size:20px; color: #F1CE3E"
                              >add_link</v-icon
                            >
                          </v-btn>
                          <v-btn
                            v-else
                            outline
                            fab
                            dark
                            small
                            color="secondary"
                            class="elevation-3"
                            @click="commentSourceDialog = true"
                          >
                            <v-icon dark style="font-size:20px; color: #F1CE3E"
                              >link_off</v-icon
                            >
                          </v-btn>
                          <v-btn
                            fab
                            dark
                            small
                            class="titles"
                            @click="
                              addMessageThread(n.forum_id, item.messageID)
                            "
                          >
                            <v-icon
                              dark
                              style="font-size:20px;border-radius:50px"
                              >send</v-icon
                            >
                          </v-btn>
                        </div>
                      </v-layout>

                      <template
                        v-for="threadItem in item.thread"
                        pa-1
                        style="  padding-left: 10px"
                      >
                        <div
                          :key="
                            threadItem.senderID +
                              n.title +
                              n.forum_id +
                              ' desktop'
                          "
                          v-show="
                            item.threads &&
                              (indexOfQTC(n) == -1 || indexOfQTC(n) == item.QTC)
                          "
                          class="elevation-1 "
                          style="background:white;border-radius: 20px;  padding: 20px; padding-bottom:2px; margin:7px; margin-left: 45px; "
                        >
                          <v-card v-show="item.threads" flat pa-1>
                            <div>
                              <p
                                pa-2
                                style="font-weight: bold; font-size:16px; padding-top: 2px;padding-left: 10px;margin-bottom: 0px;  text-transform: capitalize; clear:both;"
                                class="text-wrap"
                                @click="
                                  $router.push(
                                    '/profile/' + threadItem.senderID
                                  )
                                "
                              >
                                {{ threadItem.sender }}
                              </p>
                              <p
                                pa-2
                                style="font-weight: bold; font-size:12px; padding-top: 2px;padding-left: 10px;margin-bottom: 0px;  text-transform: capitalize; clear:both;"
                                class="text-wrap"
                              >
                                {{ threadItem.time }}
                              </p>
                              <p
                                class="text-wrap"
                                style="font-size: 16px;margin-bottom: 0px;padding-left: 10px;overflow-wrap: break-word;padding-right: 10px;display: block;white-space: normal;word-wrap: break-word;width: auto; clear:right"
                                pa-1
                              >
                                {{ threadItem.message }}
                              </p>
                            </div>
                            <div
                              style="white-space: pre-wrap;display: flex;margin: 6px; justify-content: flex-end; margin-right: -14px;"
                            >
                              <div
                                class="primary elevation-3"
                                style="    width: min-content;border-radius: 20px;display: flex;text-align: center;"
                              >
                                <v-btn
                                  flat
                                  fab
                                  class="danger elevation-4"
                                  small
                                  v-show="userID != threadItem.senderID"
                                  style="color:white; "
                                  @click="
                                    setReport(
                                      n.forum_id,
                                      n.title,
                                      item.messageID,
                                      item.message,
                                      threadItem.messageID,
                                      threadItem.message
                                    )
                                  "
                                >
                                  <v-icon dark style="font-size:20px; "
                                    >more_horiz</v-icon
                                  >
                                </v-btn>
                                <v-btn
                                  flat
                                  fab
                                  class="danger elevation-4"
                                  small
                                  v-show="userID == threadItem.senderID"
                                  style="color:white; "
                                  @click="
                                    removeMessageThread(
                                      n.forum_id,
                                      item.messageID,
                                      threadItem.messageID
                                    )
                                  "
                                >
                                  <v-icon dark style="font-size:20px; "
                                    >delete_outline</v-icon
                                  >
                                </v-btn>

                                <v-btn
                                  v-show="threadItem.links.length > 0"
                                  @click="
                                    setLink(
                                      threadItem.message,
                                      threadItem.links,
                                      n.tags
                                    )
                                  "
                                  flat
                                  class="secondary elevation-4 titles--text"
                                  fab
                                  small
                                >
                                  <v-icon dark style="font-size:20px; "
                                    >link</v-icon
                                  >
                                </v-btn>

                                <v-btn
                                  outline
                                  color="secondary"
                                  text-color="secondary"
                                  v-show="
                                    !threadItem.userUpvotes.includes(userID)
                                  "
                                  class="upvote elevation-4"
                                  flat
                                  style="border-radius: 20px;  height:40px; min-width:5px;  padding: 10px; color: white;     font-weight: 600;"
                                  @click="
                                    addThreadMessageUpvote(
                                      n.forum_id,
                                      item.messageID,
                                      threadItem.messageID
                                    )
                                  "
                                >
                                  <v-icon dark style="font-size:20px; "
                                    >star_border</v-icon
                                  >
                                  &nbsp; &nbsp; {{ threadItem.count }}
                                </v-btn>
                                <v-btn
                                  outline
                                  color="secondary"
                                  text-color="secondary"
                                  v-show="
                                    threadItem.userUpvotes.includes(userID)
                                  "
                                  flat
                                  class="upvote elevation-4"
                                  lighten-2
                                  @click="
                                    removeThreadMessageUpvote(
                                      n.forum_id,
                                      item.messageID,
                                      threadItem.messageID
                                    )
                                  "
                                  style="border-radius: 20px;  height:40px; min-width:5px; padding: 10px;  color:white;  font-weight: 600;"
                                >
                                  <v-icon dark style="font-size:20px; "
                                    >star</v-icon
                                  >
                                  &nbsp; {{ threadItem.count }}
                                </v-btn>
                              </div>
                            </div>
                          </v-card>
                        </div>
                      </template>
                    </template>
                  </v-list>
                  <v-card
                    v-else
                    style="text-align: center; display:inline; background:white;"
                  >
                    <h3
                      class="black--text"
                      style="padding: 25px;  margin: 10px; border-radius: 15px; font-size: x-large;"
                    >
                      Start the Discussion
                    </h3>
                  </v-card>
                </div>
              </div>
            </v-card>
          </v-card>
        </div>

        <!-- mobile -->
        <div
          v-bind="n"
          :key="n.forum_id + 'forum'"
          style="display:inline"
          class="hidden-lg-and-up"
        >
          <v-card
            class="elevation-0"
            style="max-width: 640px;width: -webkit-fill-available;background: #00008b00; margin:auto"
          >
            <v-card
              class=" primary shadow"
              style=" border-radius: 10px; margin-bottom:25px; padding-bottom: 1px; "
            >
              <div
                style="display: flex; justify-content: space-between; color: white; align-items: center; padding-left: 10px; font-weight: 600;"
              >
                {{ n.time }}
                <!-- <img
                  src="../assets/Concord_Logo_Final.webp"
                  style="height: 21px; margin: 8px; margin-left: 12px;"
                /> -->
                <v-btn
                  flat
                  small
                  style="color:white; margin: 10px; padding: 0 !important; min-width: 25px !important; margin-top: 5px; margin-bottom: 5px; border-radius: 20px;"
                  @click="setReport(n.forum_id, n.title, '', '', '', '')"
                >
                  <v-icon dark style="font-size:20px; ">more_horiz</v-icon>
                </v-btn>
              </div>
              <v-carousel
                lazy
                class="elevation-0 carousel-concormobile"
                height="100%"
                style=" padding: 7px; padding-top: 0px;"
                hide-delimiters
                :cycle="false"
                :continuous="false"
                v-model="caro['mobile' + n.forum_id]"
                transition="fade-transition"
              >
                <v-carousel-item
                  flat
                  v-bind="n"
                  v-for="(item, i) in n.items"
                  :alt="n.title"
                  :key="i + n.title + n.forum_id + 'caro'"
                  :src="item"
                  height="100%"
                  style="max-width: 700px; border-radius: 10px; border: 1px solid white"
                >
                  <div
                    v-if="news_index == 0 && i == 0 && !seen"
                    id="desktopTutorial"
                    class="titles"
                    style="float: left;
                    position: relative;
                    z-index: 1000;
                    padding: 5px;
                    color: white;
                    font-weight: bold;
                    opacity: .8; font-size: 2vh;
                    display: flex;
                    width: 80%;
                    justify-content: center;
                    align-items: center;
                    left: 50%;
                    top: 51%;
                    border-radius: 10px;
                    -webkit-transform: translate(-50%, -50%);
                    transform: translate(-50%, -50%);"
                  >
                    <v-icon
                      color="white"
                      style="font-size: 2.5vw; margin-left:3px; background: #ffffff30; border-radius: 50px;"
                      >chevron_right</v-icon
                    >&nbsp; Tap or Swipe To See More &nbsp;
                    <v-icon
                      color="white"
                      style="font-size: 2.5vw; margin-left:3px; background: #ffffff30; border-radius: 50px;"
                      >chevron_right</v-icon
                    >
                  </div>
                  <v-btn
                    class="carousel-concord-btn primary  "
                    fab
                    dark
                    small
                    style="color: white;opacity:.8; float:right"
                  >
                    <span style="font-size:11px"
                      >{{ i + 1 }}/{{ n.items.length }}</span
                    >
                  </v-btn>
                </v-carousel-item>
              </v-carousel>
              <div
                style="    display: flex; justify-content: center; margin-top: -10px;"
              >
                <div
                  v-for="i in n.items.length"
                  :key="i + 'mobile slides' + n.forum_id"
                >
                  <v-icon
                    v-if="i - 1 == caro['mobile' + n.forum_id]"
                    color="secondary"
                    style="font-size: 10px; margin-left:3px;"
                    >adjust</v-icon
                  >
                  <v-icon
                    v-else
                    color="white"
                    style="font-size: 10px; margin-left:3px;"
                    >adjust</v-icon
                  >
                </div>
              </div>

              <v-layout
                row
                style="padding: 0% 2% 3%; text-align:center;display: block;"
              >
                <v-list
                  style=" padding-top:0; padding-bottom: 0; background-color:#6aaaff05"
                >
                  <div
                    v-show="n.tags.length > 0"
                    style="overflow-wrap: anywhere; white-space: break-spaces; margin:5px"
                  >
                    <template v-for="(tag, i) in n.tags">
                      <v-chip
                        v-if="i != n.tags.length - 1"
                        :key="tag + n.title + n.forum_id + 'tags'"
                        @click="pushTag(tag)"
                        color="titles"
                        class="ma-2 elevation-4"
                        text-color="white"
                        >{{ tag }}</v-chip
                      >
                      <v-chip
                        v-else
                        :key="tag + n.title + n.forum_id + 'tags'"
                        @click="pushTag(tag)"
                        color="secondary"
                        class="ma-2 elevation-4"
                        text-color="titles"
                        >{{ tag }}</v-chip
                      >
                    </template>
                  </div>

                  <div
                    style="overflow-wrap: anywhere; white-space: break-spaces;"
                  >
                    <!-- <v-btn
                      flat
                      class="danger elevation-4"
                      fab
                      small
                      style="color:white;"
                      @click="setReport(n.forum_id, n.title, '', '', '', '')"
                    >
                      <v-icon dark style="font-size:20px; ">more_horiz</v-icon>
                    </v-btn> -->

                    <v-btn
                      v-show="n.links.length > 0"
                      @click="setLink(n.title, n.links, n.tags)"
                      class="secondary elevation-4 titles--text"
                      flat
                      fab
                      small
                    >
                      <v-icon dark style="font-size:20px; ">link</v-icon>
                    </v-btn>
                    <v-btn
                      outline
                      color="secondary"
                      text-color="secondary"
                      v-show="!n.userUpvotes.includes(userID)"
                      flat
                      class="upvote elevation-4"
                      style="border-radius: 20px;  height:40px; min-width:5px; color:white; padding: 10px;     font-weight: 600;"
                      @click="addStoryUpvote(n.forum_id)"
                    >
                      <v-icon dark style="font-size:20px; ">star_border</v-icon>
                      &nbsp; {{ n.count }}
                    </v-btn>
                    <v-btn
                      outline
                      color="secondary"
                      text-color="secondary"
                      v-show="n.userUpvotes.includes(userID)"
                      class="upvote elevation-4"
                      flat
                      lighten-2
                      @click="removeStoryUpvote(n.forum_id)"
                      style="border-radius: 20px;  height:40px; min-width:5px; color:white;padding: 10px;    font-weight: 600;"
                    >
                      <v-icon dark style="font-size:20px; ">star</v-icon>
                      &nbsp; {{ n.count }}
                    </v-btn>

                    <v-btn
                      class="titles elevation-4"
                      v-show="n.chat"
                      @click="(n.chat = false), updateView()"
                      flat
                      pa-1
                      style="border-radius: 20px;min-width: 5px;padding:10px;height:40px;margin-bottom: 6px;  color:white;  font-weight: 600;"
                    >
                      <v-icon dark small style="font-size:22px; "
                        >speaker_notes</v-icon
                      >
                      &nbsp; {{ n.sortedMessages.length }}
                    </v-btn>
                    <v-btn
                      class="titles elevation-4"
                      v-show="!n.chat"
                      @click="(n.chat = true), updateView()"
                      flat
                      pa-1
                      style="border-radius: 20px; min-width: 5px;padding:10px;height:40px;margin-bottom: 6px; color:white;   font-weight: 600;"
                    >
                      <v-icon dark small style="font-size:22px; "
                        >speaker_notes_off</v-icon
                      >
                      &nbsp; {{ n.sortedMessages.length }}
                    </v-btn>
                    <v-btn
                      flat
                      class="danger elevation-4 white--text"
                      fab
                      small
                      style="color:white; "
                      @click="shareStory(n, n.tags)"
                    >
                      <v-icon dark style="font-size:20px; ">ios_share</v-icon>
                    </v-btn>
                  </div>
                </v-list>

                <v-flex
                  style="padding-bottom: 5px; padding-top: 5px; margin-left: 6px; margin-right: 6px;"
                >
                  <v-select
                    id="desktopQTC"
                    :items="n.QTC"
                    v-model="n.chosen"
                    cache-items
                    flat
                    hide-no-data
                    hide-details
                    label="Respond to or Filter by a Question to Consider"
                    solo
                    dense
                    clearable
                    style="    white-space: pre-wrap;"
                    @change="n.chat = true"
                  ></v-select>
                </v-flex>

                <div
                  class=" elevation-4"
                  style="display: flex; margin-top: 10px; margin-left: 6px; margin-right: 6px; border-radius: 10px;  background: white;"
                >
                  <v-textarea
                    maxlength="1000"
                    style="padding:10px; border-radius:20px;"
                    counter="1000"
                    clearable
                    no-resize
                    :id="n.forum_id"
                    rows="2"
                    shaped
                    v-model="n.input"
                    label="Discuss..."
                    v-on:keyup.enter="
                      addMessage(n.forum_id), (n.chat = true), updateView()
                    "
                  >
                  </v-textarea>
                  <div
                    class="primary"
                    style="display:grid; border-radius: 0px 10px 10px 0px; border: 1px solid white !important; border-left: 0;"
                  >
                    <v-btn
                      v-if="
                        comment_id != n.forum_id ||
                          comment_source_isThread != false
                      "
                      outline
                      fab
                      dark
                      small
                      color="secondary"
                      class="elevation-3"
                      @click="
                        (commentSourceDialog = true),
                          (commentSources = ''),
                          (commentSources1 = []),
                          (comment_id = n.forum_id),
                          (comment_source_isThread = false)
                      "
                    >
                      <v-icon dark style="font-size:20px; color: #F1CE3E"
                        >add_link</v-icon
                      >
                    </v-btn>
                    <v-btn
                      v-else
                      outline
                      fab
                      dark
                      small
                      color="secondary"
                      class="elevation-3"
                      @click="commentSourceDialog = true"
                    >
                      <v-icon dark style="font-size:20px; color: #F1CE3E"
                        >link_off</v-icon
                      >
                    </v-btn>

                    <v-btn
                      fab
                      dark
                      small
                      class="titles elevation-3"
                      @click="
                        addMessage(n.forum_id), (n.chat = true), updateView()
                      "
                    >
                      <v-icon dark style="font-size:20px;  border-radius:50px"
                        >send</v-icon
                      >
                    </v-btn>
                  </div>
                </div>
              </v-layout>

              <div
                class="scroll-y chatbackground elevation-4"
                v-show="n.chat"
                id="scroll-target"
                style="width: auto;max-height: 560px; border-radius: 10px; margin:12px;     margin-top: 0px;"
              >
                <v-list
                  v-if="n.sortedMessages.length > 0"
                  id="scroll-container"
                  class="chatbackground"
                  two-line
                  v-scroll:#scroll-target
                  style="padding-top: 0px; padding-bottom: 0px;"
                >
                  <template
                    v-for="item in n.sortedMessages"
                    pa-1
                    style="min-height:72px; "
                  >
                    <div
                      :key="
                        item.senderID + n.title + n.forum_id + item.messageID
                      "
                      class="elevation-1 "
                      style="border-radius: 20px;  padding: 20px; padding-bottom:2px; margin:7px; background:white;"
                      v-show="indexOfQTC(n) == -1 || indexOfQTC(n) == item.QTC"
                    >
                      <div>
                        <p
                          pa-2
                          style="font-weight: bold; font-size:16px; padding-top: 2px;margin-bottom: 0px;  text-transform: capitalize; clear:both;"
                          class="text-wrap"
                          @click="$router.push('/profile/' + item.senderID)"
                        >
                          {{ item.sender }}
                        </p>
                        <p
                          v-show="!item.deleted"
                          pa-2
                          style="font-weight: bold;font-size:12px; padding-top: 2px;margin-bottom: 0px;  text-transform: capitalize; clear:both;"
                          class="text-wrap"
                        >
                          {{ item.time }}
                        </p>
                      </div>

                      <p
                        v-show="!item.deleted"
                        class="text-wrap"
                        style="font-size: 16px;margin-bottom: 0px;overflow-wrap: break-word;padding-right: 10px; display:block;white-space: normal;word-wrap: break-word;width: auto; clear:right"
                        pa-1
                      >
                        {{ item.message }}
                      </p>
                      <div
                        style="white-space: pre-wrap; display: flex; margin: 6px; justify-content: flex-end; margin-right: -14px;"
                      >
                        <div
                          style="width: min-content;border-radius: 20px;display: flex;text-align: center;"
                          class="primary elevation-3"
                        >
                          <v-btn
                            flat
                            fab
                            class="danger elevation-4"
                            small
                            style=" color:white; "
                            v-show="userID != item.senderID && !item.deleted"
                            @click="
                              setReport(
                                n.forum_id,
                                n.title,
                                item.messageID,
                                item.message,
                                '',
                                ''
                              )
                            "
                          >
                            <v-icon dark style="font-size:20px; "
                              >more_horiz</v-icon
                            >
                          </v-btn>
                          <v-btn
                            flat
                            fab
                            class="danger elevation-4"
                            small
                            v-show="userID == item.senderID && !item.deleted"
                            style="color:white;"
                            @click="removeMessage(n.forum_id, item.messageID)"
                          >
                            <v-icon dark style="font-size:20px; "
                              >delete_outline</v-icon
                            >
                          </v-btn>

                          <v-btn
                            v-show="item.links.length > 0"
                            @click="setLink(item.message, item.links, n.tags)"
                            class="secondary elevation-4 titles--text"
                            flat
                            fab
                            small
                          >
                            <v-icon dark style="font-size:20px; ">link</v-icon>
                          </v-btn>

                          <v-btn
                            outline
                            color="secondary"
                            text-color="secondary"
                            v-show="
                              !item.userUpvotes.includes(userID) &&
                                !item.deleted
                            "
                            flat
                            class="upvote elevation-4"
                            style="border-radius: 20px;  height:40px; min-width:5px; color:white;  padding: 10px;     font-weight: 600;"
                            @click="
                              addMessageUpvote(n.forum_id, item.messageID)
                            "
                          >
                            <v-icon dark style="font-size:20px; "
                              >star_border</v-icon
                            >
                            &nbsp; {{ item.count }}
                          </v-btn>

                          <v-btn
                            outline
                            color="secondary"
                            text-color="secondary"
                            v-show="
                              item.userUpvotes.includes(userID) && !item.deleted
                            "
                            flat
                            class="upvote elevation-4"
                            lighten-2
                            @click="
                              removeMessageUpvote(n.forum_id, item.messageID)
                            "
                            style="border-radius: 20px;  height:40px; min-width:5px;  padding: 10px; color:white;    font-weight: 600;"
                          >
                            <v-icon dark style="font-size:20px; ">star</v-icon>
                            &nbsp; {{ item.count }}
                          </v-btn>

                          <v-btn
                            class="titles elevation-4"
                            v-show="item.threads"
                            @click="(item.threads = false), updateView()"
                            flat
                            pa-1
                            style="border-radius: 20px;min-width: 5px; padding: 10px;  height:40px;margin-bottom: 6px;  color:white;  font-weight: 600;"
                          >
                            <v-icon dark small style="font-size:22px; "
                              >speaker_notes</v-icon
                            >
                            &nbsp; {{ item.thread.length }}
                          </v-btn>
                          <v-btn
                            class="titles elevation-4"
                            v-show="!item.threads"
                            @click="(item.threads = true), updateView()"
                            flat
                            pa-1
                            style="border-radius: 20px; min-width: 5px; padding: 10px; height:40px;margin-bottom: 6px; color:white;  font-weight: 600;"
                          >
                            <v-icon dark small style="font-size:22px; "
                              >reply</v-icon
                            >
                            &nbsp; {{ item.thread.length }}
                          </v-btn>
                        </div>
                      </div>
                    </div>

                    <v-layout
                      v-show="
                        item.threads &&
                          (indexOfQTC(n) == -1 || indexOfQTC(n) == item.QTC)
                      "
                      :key="item + n.forum_id + item.messageID + 'threads'"
                      class="elevation-1 "
                      row
                      style=" border-radius: 20px;margin: 7px;margin-left: 45px; background:white"
                    >
                      <v-textarea
                        maxlength="1000"
                        clearable
                        no-resize
                        counter="1000"
                        style="padding:10px;  color:white; margin-left:20px"
                        rows="2"
                        :id="item.messageID"
                        label="Respond..."
                        v-model="item.input"
                        v-on:keyup.enter="
                          addMessageThread(n.forum_id, item.messageID)
                        "
                      >
                      </v-textarea>
                      <div
                        class="primary"
                        style="display:grid; border-radius: 0px 20px 20px 0px; border: 1px solid white !important; border-left: 0px;"
                      >
                        <v-btn
                          v-if="
                            comment_id != n.forum_id ||
                              comment_source_isThread != true
                          "
                          outline
                          fab
                          dark
                          small
                          color="secondary"
                          class="elevation-3"
                          @click="
                            (commentSourceDialog = true),
                              (commentSources = ''),
                              (commentSources1 = []),
                              (comment_id = n.forum_id),
                              (comment_source_isThread = true)
                          "
                        >
                          <v-icon dark style="font-size:20px; color: #F1CE3E"
                            >add_link</v-icon
                          >
                        </v-btn>
                        <v-btn
                          v-else
                          outline
                          fab
                          dark
                          small
                          color="secondary"
                          class="elevation-3"
                          @click="commentSourceDialog = true"
                        >
                          <v-icon dark style="font-size:20px; color: #F1CE3E"
                            >link_off</v-icon
                          >
                        </v-btn>
                        <v-btn
                          fab
                          dark
                          small
                          class="titles"
                          @click="addMessageThread(n.forum_id, item.messageID)"
                        >
                          <v-icon dark style="font-size:20px;border-radius:50px"
                            >send</v-icon
                          >
                        </v-btn>
                      </div>
                    </v-layout>

                    <template
                      v-for="threadItem in item.thread"
                      pa-1
                      style="  padding-left: 10px"
                    >
                      <div
                        :key="threadItem.senderID + n.title + n.forum_id"
                        v-show="
                          item.threads &&
                            (indexOfQTC(n) == -1 || indexOfQTC(n) == item.QTC)
                        "
                        class="elevation-1 "
                        style="background:white;border-radius: 20px;  padding: 20px; padding-bottom:2px; margin:7px; margin-left: 45px; "
                      >
                        <v-card v-show="item.threads" flat pa-1>
                          <div>
                            <p
                              pa-2
                              style="font-weight: bold; font-size:16px; padding-top: 2px;padding-left: 10px;margin-bottom: 0px;  text-transform: capitalize; clear:both;"
                              class="text-wrap"
                              @click="
                                $router.push('/profile/' + threadItem.senderID)
                              "
                            >
                              {{ threadItem.sender }}
                            </p>
                            <p
                              pa-2
                              style="font-weight: bold; font-size:12px; padding-top: 2px;padding-left: 10px;margin-bottom: 0px;  text-transform: capitalize; clear:both;"
                              class="text-wrap"
                            >
                              {{ threadItem.time }}
                            </p>
                            <p
                              class="text-wrap"
                              style="font-size: 16px;margin-bottom: 0px;padding-left: 10px;overflow-wrap: break-word;padding-right: 10px;display: block;white-space: normal;word-wrap: break-word;width: auto; clear:right"
                              pa-1
                            >
                              {{ threadItem.message }}
                            </p>
                          </div>
                          <div
                            style="white-space: pre-wrap;display: flex;margin: 6px; justify-content: flex-end; margin-right: -14px;"
                          >
                            <div
                              class="primary elevation-3"
                              style="    width: min-content;border-radius: 20px;display: flex;text-align: center;"
                            >
                              <v-btn
                                flat
                                fab
                                class="danger elevation-4"
                                small
                                v-show="userID != threadItem.senderID"
                                style="color:white; "
                                @click="
                                  setReport(
                                    n.forum_id,
                                    n.title,
                                    item.messageID,
                                    item.message,
                                    threadItem.messageID,
                                    threadItem.message
                                  )
                                "
                              >
                                <v-icon dark style="font-size:20px; "
                                  >more_horiz</v-icon
                                >
                              </v-btn>
                              <v-btn
                                flat
                                fab
                                class="danger elevation-4"
                                small
                                v-show="userID == threadItem.senderID"
                                style="color:white;"
                                @click="
                                  removeMessageThread(
                                    n.forum_id,
                                    item.messageID,
                                    threadItem.messageID
                                  )
                                "
                              >
                                <v-icon dark style="font-size:20px; "
                                  >delete_outline</v-icon
                                >
                              </v-btn>

                              <v-btn
                                v-show="threadItem.links.length > 0"
                                @click="
                                  setLink(
                                    threadItem.message,
                                    threadItem.links,
                                    n.tags
                                  )
                                "
                                flat
                                class="secondary elevation-4 titles--text"
                                fab
                                small
                              >
                                <v-icon dark style="font-size:20px; "
                                  >link</v-icon
                                >
                              </v-btn>

                              <v-btn
                                outline
                                color="secondary"
                                text-color="secondary"
                                v-show="
                                  !threadItem.userUpvotes.includes(userID)
                                "
                                class="upvote elevation-4"
                                flat
                                style="border-radius: 20px;  height:40px; min-width:5px;  padding: 10px; color: white;     font-weight: 600;"
                                @click="
                                  addThreadMessageUpvote(
                                    n.forum_id,
                                    item.messageID,
                                    threadItem.messageID
                                  )
                                "
                              >
                                <v-icon dark style="font-size:20px; "
                                  >star_border</v-icon
                                >
                                &nbsp; &nbsp; {{ threadItem.count }}
                              </v-btn>
                              <v-btn
                                outline
                                color="secondary"
                                text-color="secondary"
                                v-show="threadItem.userUpvotes.includes(userID)"
                                flat
                                class="upvote elevation-4"
                                lighten-2
                                @click="
                                  removeThreadMessageUpvote(
                                    n.forum_id,
                                    item.messageID,
                                    threadItem.messageID
                                  )
                                "
                                style="border-radius: 20px;  height:40px; min-width:5px; padding: 10px;  color:white;  font-weight: 600;"
                              >
                                <v-icon dark style="font-size:20px; "
                                  >star</v-icon
                                >
                                &nbsp; {{ threadItem.count }}
                              </v-btn>
                            </div>
                          </div>
                        </v-card>
                      </div>
                    </template>
                  </template>
                </v-list>
                <v-card
                  v-else
                  style="text-align: center; display:inline; background:white;"
                >
                  <h3
                    style="padding: 25px; font-size: x-large;"
                    class="black--text"
                  >
                    Start the Discussion
                  </h3>
                </v-card>
              </div>
            </v-card>
          </v-card>
        </div>
      </template>
      <div v-show="loading === true">
        <div class="fingerprint-spinner">
          <div class="spinner-ring"></div>
          <div class="spinner-ring"></div>
          <div class="spinner-ring"></div>
          <div class="spinner-ring"></div>
          <div class="spinner-ring"></div>
          <div class="spinner-ring"></div>
          <div class="spinner-ring"></div>
          <div class="spinner-ring"></div>
          <div class="spinner-ring"></div>
        </div>
      </div>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from "vuex";

import firebase from "firebase";
import "firebase/firestore";

export default {
  data() {
    return {
      loading: true,
      max: false,
      userEmail: "",
      concordTab: true,
      userID: "",
      commentSourceDialog: false,
      commentSources: "",
      commentSources1: [],
      comment_id: "",
      comment_source_isThread: false,
      name: "",
      avatar: "",
      imageUrl: "",
      updated: "",
      gender: "",
      location: [
        "United States",
        "Alabama",
        "Alaska",
        "American Samoa",
        "Arizona",
        "Arkansas",
        "California",
        "Colorado",
        "Connecticut",
        "Delaware",
        "Washington D.C.",
        "Florida",
        "Georgia",
        "Guam",
        "Hawaii",
        "Idaho",
        "Illinois",
        "Indiana",
        "International",
        "Iowa",
        "Kansas",
        "Kentucky",
        "Louisiana",
        "Maine",
        "Maryland",
        "Massachusetts",
        "Michigan",
        "Minnesota",
        "Mississippi",
        "Missouri",
        "Montana",
        "Nebraska",
        "Nevada",
        "New Hampshire",
        "New Jersey",
        "New Mexico",
        "New York",
        "North Carolina",
        "North Dakota",
        "Northern Mariana Islands",
        "Ohio",
        "Oklahoma",
        "Oregon",
        "Pennsylvania",
        "Puerto Rico",
        "Rhode Island",
        "South Carolina",
        "South Dakota",
        "Tennessee",
        "Texas",
        "U.S. Virgin Islands",
        "Utah",
        "Vermont",
        "Virginia",
        "Washington",
        "West Virginia",
        "Wisconsin",
        "Wyoming",
      ],
      birthdate: "",
      editing: false,
      message: "",
      messageThread: "",
      image: null,
      imageExt: "",
      show: false,
      news: [],
      concordNews: [],
      userNews: [],
      scrolledToBottom: false,
      hover: false,
      reportDialog: false,
      chosenReason: "",
      reportReason: "",
      reportForumID: "",
      reportForumTitle: "",
      reportMessageID: "",
      reportMessage: "",
      reportSubmessageID: "",
      reportSubmessage: "",
      reportAutocomplete: {
        story: [
          "Multiple typos",
          "Inappropriate language, hate speech, racist language, and profanity",
          "Duplicate Post",
          "Extraneous Content",
          "Harassment or Threats",
          "Improperly Cited Information",
          "Copyright Violation",
          "Missing Key Element",
          "Too Disjoint",
          "Design Error",
        ],
        comment: [
          "Inappropriate language, hate speech, racist language, and profanity",
          "Spam",
          "Harassment or Threats",
          "Solicitation",
          "Copyright Violation",
        ],
      },
      linkDialog: false,
      link_forumTitle: "",
      link_links: [],
      link_tags: [],
      caro: {},
      savedCaros: {},
      snackbar: false,
      searching: false,
      seen: false
    };
  },
  watch: {
    scrolledToBottom() {
      if (this.scrolledToBottom == true) {
        //search for more news

        this.loading = true;
        this.startSearch();
        this.scrolledToBottom = false;
      }
    },
    caro: {
      handler(newCaro) {
        Object.entries(newCaro).forEach((entry) => {
          const [key, value] = entry;
          var forum_name = key.replace(/(mobile|desktop)/, "");
          if (!this.savedCaros[key]) {
            this.savedCaros[key] = 0;
          }
          if (value > this.savedCaros[key]) {
            var forum_result = this.news.filter((obj) => {
              return obj.forum_id === forum_name;
            });

            this.$store.dispatch("addInteract", {
              tags: forum_result[0].tags,
              value: (1 / forum_result[0].items.length) * 500000,
            });
            this.savedCaros[key] = value;
          }
        });
      },
      deep: true,
    },
  },
  computed: {
    ...mapState(["user", "userProfile"]),
  },
  // components: {
  //   vToolTip: tooltip
  // },
  mounted: function() {
    var self = this;
    this.scroll();
    setTimeout(async function() {
      self.userEmail = self.user.email;

      await self.search();

      if (self.userProfile.updated) {
        self.updated = self.userProfile.updated;
      }
      if (self.userProfile.uid) {
        self.userID = self.userProfile.uid;
      }
      if (self.userProfile.name) {
        self.name = self.userProfile.name;
      }
      if (self.userProfile.gender) {
        self.gender = self.userProfile.gender;
      }
      if (self.userProfile.birthdate) {
        self.birthdate = self.userProfile.birthdate;
      }
      if (self.userProfile.phone) {
        self.phone = self.userProfile.phone;
      }
      if (self.userProfile.avatar) {
        self.avatar = self.userProfile.avatar;
      }
      if (self.userProfile.photoURL) {
        self.imageUrl = self.userProfile.photoURL;
      }
      if (self.userProfile.joined) {
        self.joined = self.userProfile.joined;
      }
      if (self.userProfile.updated) {
        self.updated = self.userProfile.updated;
      }
      if (self.userProfile.imageExt) {
        self.imageExt =
          "https://firebasestorage.googleapis.com/v0/b/mirror2019-b60e0.appspot.com/o/users%2F" +
          self.user.uid +
          self.userProfile.imageExt +
          "?alt=media";
      }
      self.loading = false;
    }, 2000);

    setTimeout(function(){self.seen = true},11000)
  },
  methods: {
    shareStory(story, tags) {
      if (navigator.share) {
        navigator
          .share({
            title: story.title,
            text: story.title,
            url: `https://concordreport.com/share/${story.forum_id}`,
          })
          .catch((error) => {
            // eslint-disable-next-line no-console
            console.log("Error sharing", error);
          });
      } else {
        navigator.clipboard.writeText(
          `https://concordreport.com/share/${story.forum_id}`
        );
        this.snackbar = true;
      }
      this.$store.dispatch("addInteract", {
        tags: tags,
        value: 500000,
      });
    },
    indexOfQTC(n) {
      if (n.QTC) {
        return n.QTC.indexOf(n.chosen);
      } else {
        return -1;
      }
    },
    linkTabs() {
      this.$nextTick(() => {
        this.commentSources1.push(this.commentSources.split(",")[0]);
        this.commentSources = "";
      });
    },
    getCurrImageI(forum) {
      var div = document.getElementById(`${forum}_images`);
      var id = div
        .getElementsByClassName("v-window__container")[0]
        .outerText.charAt(0);
      // if (!div.getElementsByClassName('v-carousel__next')[0].onclick) {
      //     div.getElementsByClassName('v-carousel__next')[0].onclick = this.getCurrImageI(forum)
      //     div.getElementsByClassName('v-carousel__prev')[0].onclick = this.getCurrImageI(forum)
      // }
      return parseInt(id) - 1;
    },
    setLink(forumTitle, links, tags) {
      this.linkDialog = true;
      this.link_forumTitle = forumTitle;
      this.link_links = links;
      this.link_tags = tags;
    },
    concordTabNews() {
      this.concordTab = true;
      this.news = this.concordNews;
      this.max = false;
      this.startSearch();
    },
    userTab() {
      this.concordTab = false;
      this.news = this.userNews;
      this.max = false;
      this.startSearch();
    },
    resetLink() {
      this.linkDialog = false;
      this.link_forumTitle = "";
      this.link_links = [];
      this.link_tags = [];
    },
    open(link) {
      this.$store.dispatch("addInteract", {
        tags: this.link_tags.tags,
        value: 45000,
      });
      window.open("http://" + link, "_blank");
    },
    report() {
      if (this.chosenReason != "") {
        this.$store.dispatch("report", {
          forum_id: this.reportForumID,
          message_id: this.reportMessageID,
          submessage_id: this.reportSubmessageID,
          reasonstr: this.reportReason,
          chosenReason: this.chosenReason,
          concordPost: this.concordTab,
        });

        this.resetReport();
      }
    },
    setReport(
      reportForumID,
      reportForumTitle,
      reportMessageID,
      reportMessage,
      reportSubmessageID,
      reportSubmessage
    ) {
      this.reportDialog = true;
      this.reportForumID = reportForumID;
      this.reportForumTitle = reportForumTitle;
      this.reportMessageID = reportMessageID;
      this.reportMessage = reportMessage;
      this.reportSubmessageID = reportSubmessageID;
      this.reportSubmessage = reportSubmessage;
    },
    resetReport() {
      this.reportDialog = false;
      this.reportReason = "";
      this.reportForumID = "";
      this.reportForumTitle = "";
      this.reportMessageID = "";
      this.reportMessage = "";
      this.reportSubmessageID = "";
      this.reportSubmessage = "";
      this.chosenReason = "";
    },
    isProfane(line) {
      var line2 = line.toLowerCase();
      var badWords = ["nigger", "niggr", "fag", "bitch", "fuck"];
      var bool = false;
      badWords.forEach(function(word) {
        if (line2.includes(word.toLowerCase())) {
          bool = true;
        }
      });

      return bool;
    },
    scroll() {
      window.onscroll = () => {
        let bottomOfWindow =
          Math.max(
            window.pageYOffset,
            document.documentElement.scrollTop,
            document.body.scrollTop
          ) +
            window.innerHeight >=
          document.documentElement.offsetHeight - 200;
        if (bottomOfWindow) {
          this.scrolledToBottom = true;
        } else {
          this.scrolledToBottom = false;
        }
      };
    },
    getSources(id, isThread) {
      if (
        this.commentSources1 != [] &&
        id == this.comment_id &&
        isThread == this.comment_source_isThread
      ) {
        const sources = this.commentSources1;

        var i = 0;
        for (i = 0; i < sources.length; i++) {
          var reg = /(www.|http:\/\/|https:\/\/)*/;
          var str = sources[i].replace(reg, "");
          sources[i] = str.trim();
        }
        return sources;
      } else {
        return [];
      }
    },
    addMessage(id) {
      if (document.getElementById(id).value.length > 0) {
        this.news.forEach((value) => {
          if (value.forum_id === id) {
            if (this.isProfane(value.input)) {
              value.input = "";
            } else {
              const mess_id = Math.floor(Math.random() * 1000000000).toString();
              const dateNow = new Date().getTime();
              const obj = {
                sender: this.name,
                senderID: this.userID,
                message: value.input,
                time: dateNow,
                threads: false,
                links: this.getSources(id, false),
                thread: [],
                count: 0,
                messageID: mess_id,
                userUpvotes: [],
                deleted: false,
                QTC: this.indexOfQTC(value),
              };
              const obj2 = {
                sender: this.name,
                senderID: this.userID,
                message: value.input,
                time: "0 minutes ago",
                threads: false,
                links: this.getSources(id, false),
                thread: [],
                count: 0,
                messageID: mess_id,
                userUpvotes: [],
                deleted: false,
                QTC: this.indexOfQTC(value),
              };

              value.sortedMessages.push(obj2);
              value.input = "";
              this.$store.dispatch("addComment", {
                forum: value.forum_id,
                payload: obj,
              });
            }
          }
        });
        this.commentSources = "";
        this.comment_id = "";
        this.comment_source_isThread = false;
      }
    },
    removeMessage(id, message_id) {
      this.news.forEach((value) => {
        if (value.forum_id === id) {
          const index = value.sortedMessages.findIndex((object) => {
            return object.messageID == message_id;
          });
          if (
            index > -1 &&
            value.sortedMessages[index].thread &&
            value.sortedMessages[index].thread.length > 0 &&
            !value.sortedMessages[index].deleted
          ) {
            value.sortedMessages[index].message = "";
            value.sortedMessages[index].links = [];
            value.sortedMessages[index].sender = "Redacted";
            value.sortedMessages[index].senderID = "";
            value.sortedMessages[index].count = 0;
            value.sortedMessages[index].deleted = true;
          } else if (index > -1) {
            value.sortedMessages.splice(index, 1);
          }

          this.$store.dispatch("removeComment", {
            forum: value.forum_id,
            message_id: message_id,
          });
        }
      });
    },
    addMessageThread(id1, id2) {
      this.news.forEach((value) => {
        if (value.forum_id === id1) {
          value.sortedMessages.forEach((value2) => {
            if (value2.messageID === id2) {
              if (value2.input.length > 0) {
                if (this.isProfane(value2.input)) {
                  //alert
                  value2.input = "";
                } else {
                  const dateNow = new Date().getTime();
                  const mess_id = Math.floor(
                    Math.random() * 1000000000
                  ).toString();
                  const obj = {
                    sender: this.name,
                    senderID: this.userID,
                    message: value2.input,
                    time: dateNow,
                    count: 0,
                    links: this.getSources(id1, true),
                    parentID: value2.messageID,
                    messageID: mess_id,
                    userUpvotes: [],
                  };
                  const obj2 = {
                    sender: this.name,
                    senderID: this.userID,
                    message: value2.input,
                    time: "0 minutes ago",
                    count: 0,
                    links: this.getSources(id1, true),
                    parentID: value2.messageID,
                    messageID: mess_id,
                    userUpvotes: [],
                  };

                  value2.thread.push(obj2);
                  value2.input = "";
                  this.$store.dispatch("addThread", {
                    forum: value.forum_id,
                    message: value2.messageID,
                    payload: obj,
                  });
                  this.commentSources = "";
                  this.comment_id = "";
                  this.comment_source_isThread = false;
                }
              }
            }
          });
        }
      });
    },
    removeMessageThread(id1, id2, thread_id) {
      this.news.forEach((value) => {
        if (value.forum_id === id1) {
          value.sortedMessages.forEach(async (value2) => {
            if (value2.messageID === id2) {
              const index = value2.thread.findIndex((object) => {
                return object.messageID == thread_id;
              });
              if (index > -1) {
                value2.thread.splice(index, 1);
              }
              await this.$store.dispatch("removeThread", {
                forum: value.forum_id,
                message: value2.messageID,
                thread: thread_id,
              });
              if (value2.thread.length == 0 && value2.deleted) {
                this.removeMessage(id1, id2);
              }
            }
          });
        }
      });
    },
    addStoryUpvote(id) {
      this.news.forEach((value) => {
        if (value.forum_id === id) {
          value.userUpvotes.push(this.userID);
          value.count++;
          this.$store.dispatch("addStoryUpvote", {
            forum: value.forum_id,
          });
        }
      });
    },
    removeStoryUpvote(id) {
      this.news.forEach((value) => {
        if (value.forum_id === id) {
          const index = value.userUpvotes.indexOf(this.userID);
          if (index > -1) {
            value.userUpvotes.splice(index, 1);
          }
          value.count--;
          this.$store.dispatch("removeStoryUpvote", {
            forum: value.forum_id,
          });
        }
      });
    },
    addMessageUpvote(id, id2) {
      this.news.forEach((value) => {
        if (value.forum_id === id) {
          value.sortedMessages.forEach((value2) => {
            if (value2.messageID === id2) {
              if (!value2.userUpvotes.includes(this.userID)) {
                value2.userUpvotes.push(this.userID);
                value2.count++;
                this.$store.dispatch("addCommentUpvote", {
                  forum: value.forum_id,
                  payload: value2.messageID,
                });
              }
            }
          });
        }
      });
    },
    removeMessageUpvote(id, id2) {
      this.news.forEach((value) => {
        if (value.forum_id === id) {
          value.sortedMessages.forEach((value2) => {
            if (value2.messageID === id2) {
              if (value2.userUpvotes.includes(this.userID)) {
                const index = value2.userUpvotes.indexOf(this.userID);
                if (index > -1) {
                  value2.userUpvotes.splice(index, 1);
                }
                value2.count--;
                this.$store.dispatch("removeCommentUpvote", {
                  forum: value.forum_id,
                  payload: value2.messageID,
                });
              }
            }
          });
        }
      });
    },
    addThreadMessageUpvote(id1, id2, id3) {
      this.news.forEach((value) => {
        if (value.forum_id === id1) {
          value.sortedMessages.forEach((value2) => {
            if (value2.messageID === id2) {
              value2.thread.forEach((value3) => {
                if (value3.messageID === id3) {
                  if (!value3.userUpvotes.includes(this.userID)) {
                    value3.userUpvotes.push(this.userID);
                    value3.count++;
                    this.$store.dispatch("addThreadUpvote", {
                      forum: value.forum_id,
                      message: value2.messageID,
                      thread: value3.messageID,
                    });
                  }
                }
              });
            }
          });
        }
      });
    },
    removeThreadMessageUpvote(id1, id2, id3) {
      this.news.forEach((value) => {
        if (value.forum_id === id1) {
          value.sortedMessages.forEach((value2) => {
            if (value2.messageID === id2) {
              value2.thread.forEach((value3) => {
                if (value3.messageID === id3) {
                  if (value3.userUpvotes.includes(this.userID)) {
                    const index = value3.userUpvotes.indexOf(this.userID);
                    if (index > -1) {
                      value3.userUpvotes.splice(index, 1);
                    }
                    value3.count--;
                    this.$store.dispatch("removeThreadUpvote", {
                      forum: value.forum_id,
                      message: value2.messageID,
                      thread: value3.messageID,
                    });
                  }
                }
              });
            }
          });
        }
      });
    },
    pushTag(tag) {
      this.$store.dispatch("addInteract", {
        tags: tag,
        value: 8000,
      });

      if (this.location.includes(tag)) {
        this.$router.push({
          name: "search",
          params: {
            location: tag,
          },
        });
      } else {
        this.$router.push({
          name: "search",
          params: {
            tags: tag,
          },
        });
      }
    },
    updateView() {
      this.$forceUpdate();
    },
    notifyMe() {
      // Let's check if the browser supports notifications
      // if (!("Notification" in window)) {
      //   alert("This browser does not support desktop notification");
      // }
      // // Let's check whether notification permissions have already been granted
      // else if (Notification.permission === "granted") {
      //   // If it's okay let's create a notification
      //   var notification = new Notification("Hi there!");
      // }
      // // Otherwise, we need to ask the user for permission
      // else if (Notification.permission !== "denied") {
      //   Notification.requestPermission().then(function(permission) {
      //     // If the user accepts, let's create a notification
      //     if (permission === "granted") {
      //       var notification = new Notification("Hi there!");
      //     }
      //   });
      // }
      // At last, if the user has denied notifications, and you
      // want to be respectful there is no need to bother them any more.
    },
    formatTime(date2, value) {
      const diffTimes = date2.getTime() - value.time;
      const diffDayss = Math.floor(diffTimes / (1000 * 60 * 60 * 24));
      if (diffDayss < 1) {
        var diff = (date2.getTime() - value.time) / 1000;
        diff /= 60 * 60;
        if (diff < 1) {
          var minutes = Math.floor(diff * 60);
          if (Math.abs(Math.round(minutes)) == 1) {
            value.time = Math.abs(Math.round(minutes)) + " minute ago";
          } else {
            value.time = Math.abs(Math.round(minutes)) + " minutes ago";
          }
        } else {
          if (Math.abs(Math.round(diff)) == 1) {
            value.time = 1 + " hour ago";
          } else {
            value.time = Math.abs(Math.round(diff)) + " hours ago";
          }
        }
      } else {
        if (diffDayss == 1) {
          value.time = diffDayss + " day ago";
        } else if (diffDayss >= 7) {
          value.time = new Date(value.time).toDateString();
          value.time =
            value.time.substring(3, 10) + "," + value.time.substring(10);
        } else {
          value.time = diffDayss + " days ago";
        }
      }
      return value.time;
    },
    async startSearch() {
      await this.search();
      this.loading = false;
    },
    async search() {
      // if (("Notification" in window)) {
      //     this.notifyMe()
      // }

      var i = 0;
      var length = 3;
      var j = 0;
      var searchtags = [];
      var forum_ids = [];
      var self = this;
      searchtags.push(this.userProfile.state);
      searchtags = searchtags.concat(this.userProfile.tags);

      if (this.concordTab && !this.searching) {
        this.searching = true;
        if (this.concordNews) {
          this.concordNews.forEach((val) => {
            if (val.forum_id != undefined) {
              forum_ids.push(val.forum_id);
            }
          });
        }

        while (i < length && !self.max) {
          //query for stories (order by relevance)
          //search by location, tags, subscribed to, then time
          //not already in this.news or in newStories
          var snapshot = await firebase
            .firestore()
            .collection("concordposts")
            .where("tags", "array-contains-any", searchtags)
            .orderBy("time", "desc")
            .get();

          var snapshot2;
          if (forum_ids.length > 50) {
            snapshot2 = await firebase
              .firestore()
              .collection("concordposts")
              .orderBy("time", "desc")
              .limit(100)
              .get();
          } else if (forum_ids.length == 0 || forum_ids > 10) {
            snapshot2 = await firebase
              .firestore()
              .collection("concordposts")
              .orderBy("time", "desc")
              .limit(50)
              .get();
          } else {
            var ids = JSON.parse(JSON.stringify(forum_ids));
            snapshot2 = await firebase
              .firestore()
              .collection("concordposts")
              .where("forum_id", "not-in", ids.splice(0, 10))
              .orderBy("forum_id")
              .orderBy("time", "desc")
              .limit(50)
              .get();

            if (snapshot2.size == 0) {
              self.max = true;
              break;
            }
          }
          var d1 = snapshot.docs.map((doc) => doc.data());
          var d = snapshot2.docs.map((doc) => doc.data());
          d = d.concat(d1);

          const timenow = Date.now();
          const oneDay = 1000 * 60 * 60 * 24;

          //create rank
          d.forEach(function(val) {
            val.rank = val.time;
            const diffInTime = timenow - val.rank;
            const diffInDays = diffInTime / oneDay;

            if (diffInDays < 1) {
              val.rank -= diffInTime;
            } else if (diffInDays < 3) {
              val.rank -= diffInTime * 2;
            } else if (diffInDays < 5) {
              val.rank -= diffInTime * 3;
            } else {
              val.rank -= diffInTime * 4;
            }

            if (val.tags.includes(self.userProfile.state)) {
              val.rank += 10000000;
            }
            if (
              self.userProfile.tags.length > 0 &&
              val.tags.includes(self.userProfile.tags[0])
            ) {
              val.rank += 10000000;
            }
            if (
              self.userProfile.tags.length > 1 &&
              val.tags.includes(self.userProfile.tags[1])
            ) {
              val.rank += 10000000;
            }

            val.tags.forEach((val2) => {
              val.rank += self.userProfile.interacts[`${val2}`] * 10;
            });
          });

          d.sort(function(a, b) {
            return b.rank - a.rank;
          });
          d.forEach(function(doc) {
            j++;
            var bool = true;
            if (forum_ids) {
              forum_ids.forEach((val) => {
                if (val == doc.forum_id) {
                  bool = false;
                }
              });
            }
            if (bool && i < length) {
              var story = doc;
              forum_ids.push(story.forum_id);
              self.concordNews.push(story);
              i++;
            }
          });

          if (j >= 100 || self.max) {
            break;
          }
        }
        const date2 = new Date();
        self.concordNews.forEach(async function(value) {
          if (value.items.length == 0) {
            firebase
              .storage()
              .ref(value.itemPath)
              .listAll()
              .then(function(res) {
                var arr = [];

                for (var i = 0; i < res.items.length; i++) {
                  arr.push[""];
                }

                res.items
                  .sort(function(a, b) {
                    return a.name.substring(0, 1) - b.name.substring(0, 1);
                  })
                  .forEach(async function(itemRef) {
                    var starsRef = await firebase
                      .storage()
                      .ref(itemRef.fullPath);

                    // Get the download URL
                    await starsRef.getDownloadURL().then(function(url) {
                      const index = parseInt(itemRef.name.substring(0, 1));
                      value.items[index] = url;
                      self.$forceUpdate();
                    });
                  });
              });
          }

          if (typeof value.time != "string") {
            await value.sortedMessages.sort(async function(a, b) {
              // Time since posted
              // Likes
              // +1,600,000 for first like, 800,000 for second, 400,000 for third, 200,000 for any subsequent likes
              // Do you support them?
              // +7,200,000
              // Replies
              // +1,600,000 for first reply, 800,000 for second, 400,000 for third, 200,000 for any subsequent reply

              // count is likes
              // senderID is commenter
              // time is when posted
              var bval = b.time;
              var aval = a.time;
              if (await self.userProfile.promoted_accounts.includes(b.senderID))
                bval += 7200000;
              if (await self.userProfile.promoted_accounts.includes(a.senderID))
                aval += 7200000;

              if (b.count > 0) {
                bval += 1600000;
                if (b.count > 1) {
                  bval += 800000;
                  if (b.count > 2) {
                    bval += 400000;
                    if (b.count > 3) {
                      bval += (b.count - 3) * 200000;
                    }
                  }
                }
              }
              if (b.thread.length > 0) {
                bval += 1600000;
                if (b.thread.length > 1) {
                  bval += 800000;
                  if (b.thread.length > 2) {
                    bval += 400000;
                    if (b.thread.length > 3) {
                      bval += (b.thread.length - 3) * 200000;
                    }
                  }
                }
              }
              if (a.count > 0) {
                aval += 1600000;
                if (a.count > 1) {
                  aval += 800000;
                  if (a.count > 2) {
                    aval += 400000;
                    if (a.count > 3) {
                      aval += (a.count - 3) * 200000;
                    }
                  }
                }
              }
              if (a.thread.length > 0) {
                aval += 1600000;
                if (a.thread.length > 1) {
                  aval += 800000;
                  if (a.thread.length > 2) {
                    aval += 400000;
                    if (a.thread.length > 3) {
                      aval += (a.thread.length - 3) * 200000;
                    }
                  }
                }
              }
              return bval - aval;
            });
            value.sortedMessages.forEach(async (value2) => {
              await value2.thread.sort(async function(a, b) {
                var bval = b.time;
                var aval = a.time;
                if (
                  await self.userProfile.promoted_accounts.includes(b.senderID)
                )
                  bval += 7200000;
                if (
                  await self.userProfile.promoted_accounts.includes(a.senderID)
                )
                  aval += 7200000;

                if (b.count > 0) {
                  bval += 1600000;
                  if (b.count > 1) {
                    bval += 800000;
                    if (b.count > 2) {
                      bval += 400000;
                      if (b.count > 3) {
                        bval += (b.count - 3) * 200000;
                      }
                    }
                  }
                }
                if (a.count > 0) {
                  aval += 1600000;
                  if (a.count > 1) {
                    aval += 800000;
                    if (a.count > 2) {
                      aval += 400000;
                      if (a.count > 3) {
                        aval += (a.count - 3) * 200000;
                      }
                    }
                  }
                }
                return bval - aval;
              });
            });

            value.chat = false;

            value.time = self.formatTime(date2, value);
            value.sortedMessages.forEach((value2) => {
              value2.time = self.formatTime(date2, value2);
              value2.threads = false;

              value2.thread.forEach((value3) => {
                value3.time = self.formatTime(date2, value3);
              });
            });
          }
        });

        var unique = [];

        this.concordNews.forEach(function(val) {
          var bool = false;
          if (unique.length > 0) {
            unique.forEach(function(val2) {
              if (val2.forum_id == val.forum_id) {
                bool = true;
              }
            });
          }
          if (!bool) {
            unique.push(val);
          }
        });
        this.concordNews = unique;
        this.news = this.concordNews;
        this.searching = false;
      }
    },
  },
};
</script>
